<template>
  <div class="prizes-2021-promocode">
    Промокод: <span class="prizes-2021-promocode__value">HYPERXOZON</span>
  </div>
</template>

<script>
export default {
  name: "Prizes2021Promocode"
};
</script>

<style lang="scss">
.prizes-2021-promocode {
  margin-right: 10px;
  height: 55px;
  border: 2px solid #fbc33e;
  border-radius: 6px;

  font-size: 16px;

  flex-grow: 1;

  padding: 5px 14px;

  display: flex;
  align-items: center;

  &__value {
    font-weight: 800;
    margin-left: 5px;
  }

  @include breakpoint("sm-and-down") {
    height: 45px;
    font-size: 14px;
  }

  @include breakpoint("xs-only") {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>
